import React, { useState, useRef, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TemplateAdd from "../../../common/TemplateUtils/TemplateAdd";
import ImageSection from "../../../common/TemplateUtils/ImageSection";
import LocationSection from "../../../common/TemplateUtils/LocationSection";
import InformationSection from "../../../common/TemplateUtils/InformationSection";
import CommentsSection from "../../../common/TemplateUtils/CommentsSection";
import TemplateAccord from "../../../common/TemplateUtils/TemplateAccord";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CheckDescription from "./CheckDescription";
import AdditionalSection from "./AdditionalSection";
import uuid from "react-uuid";
import Grid from "@mui/material/Grid";
import TextInput from "./TextInput";
import Temprature from "./Temprature";
import EditIcon from "@mui/icons-material/Edit";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MenuItem from "@mui/material/MenuItem";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { BootstrapTooltip, filterObjectsUptoCategory, timestamp } from "../../../utils/services";
import { Autocomplete, Box, Fade, FormControl, Paper, Popper, TextField } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import FlagIcon from "@mui/icons-material/Flag";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import NarrativeCommentSection from "../../../common/TemplateUtils/NarrativeCommentSection";
import { addNewNarrativeComment, addNonNarrativeComment, setEditorListner, setShowCommentLibraryModal } from "../../../store/action";
import CommentLibraryModal from "../../../common/TemplateUtils/CommentLibraryModal";
import NonNarrativeAddComment from "../../../common/TemplateUtils/NonNarrativeAddComment";
import { filterSelectTag } from "../../../common/TemplateUtils/CommentLibraryHelper";
import { resolveLineRatingsFromLine, resolveRemovedDefaultRatingId, stripDefaultRating } from "../../../common/TemplateUtils/lineRatingUtils";

const MainCategory = (props) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.templates)?.categoryList;
  const templateList = useSelector((state) => state?.templates?.templateList);
  const {
    lineItem,
    categoryId,
    categoryName,
    categoryUuid,
    isInspection,
    renamingId,
    renId,
    lineId,
    AllCategoryList,
    setAllCategoryList,
    updateTemplate,
    activeRename,
    isChanged,
    checkActiveFocus,
    TriggerClick,
    selectedID,
  } = props;

  const items = lineItem.line_input_controls;
  const [expanded, setExpanded] = useState("");
  const [accordOpen, setAccordOpen] = useState(false);
  const [menu, setMenu] = useState(false);
  const [ActiveId, setActiveId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = useState({
    editDesc: false,
    editDescText: "",
    isExpanded: items.reduce((acc, item) => {
      acc[item.line_input_control_id] = true;
      return acc;
    }, {}),
    selectedItem: null,
    editLocation: false,
    isStaticExpanded: {
      description: true,
      media: true,
      location: true,
      Description: true,
      Media: true,
      Location: true,
      information: true,
      Information: true,
    },
    isCommentDialogOpen: false,
  });
  const { editDesc, editDescText, isExpanded, selectedItem, isStaticExpanded, isCommentDialogOpen } = state;
  const [placement, setPlacement] = React.useState();
  const [actives, setActives] = React.useState(false);
  const [ids, setIds] = React.useState("");
  const storeData = useSelector((state) => state.commentLibrary);
  const isHtCompany = storeData?.isHTCompany;

  const ratingData = AllCategoryList?.template?.rating_data;
  const ratingsMap = ratingData || [];
  const isTexasTemplate = AllCategoryList?.template?.is_texas === 1;
  // A TREC template in a narrative company saves into the narrative comment library,
  // even though its comment form stays non-narrative (no summary). Keyed off the
  // company key so it also holds on a direct link or refresh into the editor.
  const isTexasNarrativeCL = Boolean(isHtCompany && isTexasTemplate);
  // The template default rating only applies to lines/comments while global ratings are enabled.
  const isGlobalRatingEnabled = !!templateList?.is_global_rating_enabled;
  const [lineRatingValue, setLineRatingValue] = useState(() =>
    resolveLineRatingsFromLine(lineItem, ratingData, isGlobalRatingEnabled)
  );
  const [isRatingExpanded, setIsRatingExpanded] = useState(true);

  useEffect(() => {
    setLineRatingValue(resolveLineRatingsFromLine(lineItem, ratingData, isGlobalRatingEnabled));
  }, [lineId, lineItem?.line_rating_data, lineItem?.defaultRating_id, lineItem?.removed_default_rating_id, ratingData, isGlobalRatingEnabled]);

  const resolveRatingColor = (item) => {
    if (!item) return "#CED2DA";
    const live = ratingsMap.find((r) => r.Id === item.Id) || item;
    const c = live.color ?? live.Color ?? live.colour;
    if (typeof c === "string") return c;
    if (c && typeof c === "object") return c.hex ?? c.code ?? c.value ?? c.name ?? "#CED2DA";
    return "#CED2DA";
  };

  const resolveRatingFlagged = (item) => {
    if (!item) return false;
    const live = ratingsMap.find((r) => r.Id === item.Id) || item;
    return [1, "1", true, "true"].includes(live?.include_in_summary ?? live?.includeInSummary);
  };

  const resolveRatingName = (item) => {
    if (!item) return "";
    const live = ratingsMap.find((r) => r.Id === item.Id) || item;
    return live?.Name ?? live?.name ?? "";
  };
  const disableDnD = (isOpen, id) => {
    setActives(isOpen);
    setIds(id);
  };
  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setPlacement(newPlacement);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const unique_id = uuid();
  const small_id = unique_id;
  const uuids1 = uuid();
  const uuids2 = uuid();
  const uuids3 = uuid();
  const uuids4 = uuid();
  const uuids5 = uuid();
  const stopActive = (event) => event.stopPropagation();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : "inspections");
    setAccordOpen(!accordOpen);
  };

  const OpenMenu = (event, id) => {
    event.stopPropagation();
    stopActive(event);
    setMenu(!menu);
    setActiveId(id);
  };

  const CloseMenu = (event) => {
    stopActive(event);
    setMenu(!menu);
  };

  const handleLineRatingChange = (newValues) => {
    const values = Array.isArray(newValues) ? newValues : [];
    setLineRatingValue(values);
    // The template default is shown on every line without being stored on it, so it is dropped
    // before the line is updated — it is re-applied for display by resolveLineRatingsFromLine.
    const storedValues = stripDefaultRating(values, ratingData, isGlobalRatingEnabled);
    const catList = AllCategoryList?.template?.categories;
    const categoryIndex = catList.findIndex((cat) => cat.category_id === categoryId);
    if (categoryIndex === -1) return;
    const lineIndex = catList[categoryIndex]?.lines?.findIndex((l) => l.line_id === lineId);
    if (lineIndex === -1) return;

    const updatedCategories = catList.map((cat, idx) => {
      if (idx !== categoryIndex) return cat;
      return {
        ...cat,
        lines: cat.lines.map((line, lIdx) => {
          if (lIdx !== lineIndex) return line;
          return {
            ...line,
            defaultRating_id: storedValues.length > 0 ? Number(storedValues[0].Id) : null,
            line_rating_data: storedValues,
            // Track the template default rating being removed so it stays hidden for this line.
            removed_default_rating_id: resolveRemovedDefaultRatingId(values, ratingData, isGlobalRatingEnabled),
            updated_at: timestamp(),
          };
        }),
      };
    });

    filterObjectsUptoCategory(updatedCategories, categoryId, dispatch, categories);
    updateTemplate("noToast");
    setAllCategoryList((prev) => ({
      ...prev,
      template: {
        ...prev.template,
        categories: updatedCategories,
        updated_at: timestamp(),
      },
    }));
  };

  const HandleCreateNewDescription = (id) => {
    const val = {
      line_input_control_id: small_id,
      uuid: small_id,
      prompt: "Untitled",
      order: null,
      created_at: timestamp(),
      updated_at: timestamp(),
      is_deleted: 0,
      values: [
        {
          value: "check 1",
          is_selected: false,
          uuid: uuids1,
          created_at: timestamp(),
          updated_at: timestamp(),
          is_deleted: 0,
          order: 1,
        },
        {
          value: "check 2",
          is_selected: false,
          uuid: uuids2,
          created_at: timestamp(),
          updated_at: timestamp(),
          is_deleted: 0,
          order: 2,
        },
        {
          value: "check 3",
          is_selected: false,
          uuid: uuids3,
          created_at: timestamp(),
          updated_at: timestamp(),
          is_deleted: 0,
          order: 3,
        },
      ],
      type: "Additional Input",
      data: [],
    };
    const catList = AllCategoryList?.template?.categories;
    catList?.map((cat) => {
      cat?.lines?.map((line) => {
        if (line.line_id === id) {
          line.line_input_controls.push(val);
          setAdditional((prev) => {
            const newAdditional = line.line_input_controls.filter((obj) => {
              return obj.type === "Additional Input";
            });
            return newAdditional;
          });
        }
        return line;
      });
      return cat;
    });
    filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
    updateTemplate("noToast");
    setAllCategoryList((prev) => {
      const newCategoryList = { ...AllCategoryList };
      newCategoryList.template.categories = catList;
      newCategoryList.template.categories.updated_at = timestamp();
      return newCategoryList;
    });
  };

  const addNewCommentHandle = (id, title, comment, addToLibrary, commentTag, commentRating, commentLocation) => {
    const catList = AllCategoryList?.template?.categories;
    const categoriesData = catList.findIndex((cat) => cat.category_id === categoryId);
    let lineIndex = catList[categoriesData].lines.findIndex((line) => line.line_id === id);
    cmtRating[0].data = commentRating;
    cmtLocHolder[0].data = (commentLocation || []).map(loc => loc.name).filter(Boolean).join(", ")
    let newInputControls = [];
    newInputControls = Array.isArray(commentRating) && cmtRating[0].data.length > 0 && [cmtRating[0]];
    newInputControls = commentLocation?.length > 0 ? newInputControls.length > 0 ? [...newInputControls, cmtLocHolder[0]] : [cmtLocHolder[0]] : newInputControls;
    let newData = {
      comment_id: small_id,
      uuid: small_id,
      updated_at: timestamp(),
      prompt: title || "",
      is_mannual_prompt: 1,
      recommendation: filterSelectTag(comment?.innerHTML) || "<p></p>",
      comment_dropdowns: comment?.dropdownList || [],
      order: catList[categoriesData].lines[lineIndex].comments.length + 1,
      defaultRating_id: null,
      default_location: commentLocation,
      tags: commentTag,
      is_deleted: 0,
      is_selected: 0,
      comment_input_controls: newInputControls || [],
    };
    catList[categoriesData].lines[lineIndex].comments.push(newData);
    catList[categoriesData].lines[lineIndex].updated_at = timestamp();
    setCommentLines((prev) => {
      const tempCatList = [...catList[categoriesData].lines[lineIndex].comments];
      return tempCatList;
    });
    filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
    updateTemplate("noToast");
    if (addToLibrary) {
      if (isTexasNarrativeCL) {
        dispatch(addNewNarrativeComment({
          title: title || "",
          comment_text: newData.recommendation,
          comment_dropdowns: newData.comment_dropdowns,
          location: (commentLocation || []).map((loc) => loc.name).filter(Boolean).join(", "),
          tag_ids: commentTag || [],
          rating_ids: (commentRating || []).map((rating) => ({ ...rating, id: rating?.id ?? rating?.Id })),
          // Kept empty on purpose: a TREC template never shows a summary.
          summary_comment_text: "",
          summary_comment_dropdowns: [],
          summary_ids: [],
        }));
      } else {
        dispatch(addNonNarrativeComment({ ...newData, ratings: commentRating }));
      }
    }
    setAllCategoryList((prev) => {
      const newCategoryList = { ...AllCategoryList };
      newCategoryList.template.categories = catList;
      newCategoryList.template.categories.updated_at = timestamp();
      return newCategoryList;
    });
  };

  let DescArray = items.filter((obj) => {
    return obj.type === "Description";
  });

  let CheckBoxArray = items.filter((obj) => {
    return obj.type === "CheckBox";
  });

  let TempArray = items.filter((obj) => {
    return obj.type === "Temperature";
  });

  let TextArray = items.filter((obj) => {
    return obj.type === "TextBox";
  });

  const AdditionalIp = items
    .filter((obj) => {
      return obj.type === "Additional Input";
    })
    .sort((a, b) => a.order - b.order);

  const UnAdditional = items.filter((obj) => {
    return obj.type !== "Additional Input";
  });

  let MediaArray = items.filter((obj) => {
    return obj.type === "Media";
  });

  let LocationArray = items.filter((obj) => {
    return obj.type === "Location";
  });

  let InformationArray = items.filter((obj) => {
    return obj.type === "Information";
  });

  const commLines = lineItem?.comments;
  const [additional, setAdditional] = useState(AdditionalIp);
  const [commentLines, setCommentLines] = useState(commLines);

  React.useEffect(() => {
    setAdditional((prev) => {
      const newAdditional = [...AdditionalIp];
      return newAdditional;
    });
  }, [items]);

  React.useEffect(() => {
    if (AllCategoryList?.template?.categories?.length > 0) {
      const category = AllCategoryList.template.categories.find((cat) => cat.category_id === categoryId);
      const line = category?.lines?.find((line) => line.line_id === lineId);
      setCommentLines(line?.comments ? [...line.comments] : []);
    } else {
      setCommentLines([]);
    }
  }, [AllCategoryList]);

  const reorder = (data, startIndex, endIndex) => {
    const result = Array.from(data);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const [cmt, setCmt] = React.useState("");

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = reorder(additional, result.source.index, result.destination.index);
    reorderedItems.forEach((x, i) => {
      x.order = i + 1;
      x.updated_at = timestamp();
      return x;
    });
    setAdditional(reorderedItems);
    let additionalObjectsArray = JSON.parse(JSON.stringify(additional));
    additionalObjectsArray.sort((a, b) => a.order - b.order);
    const allLines = UnAdditional.concat(additionalObjectsArray);
    const catList = AllCategoryList?.template?.categories;
    let toastStatus = null;
    catList.map((cat) => {
      if (cat.lines !== null) {
        cat?.lines?.map((line) => {
          if (line.line_id === selectedID) {
            line.line_input_controls = allLines;
            line.updated_at = timestamp();
            toastStatus = "noToast";
          }
          return line;
        });
      }
      return cat;
    });
    if (toastStatus === "noToast") {
      filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
      updateTemplate("noToast");
      setAllCategoryList((prev) => {
        const newCategoryList = { ...AllCategoryList };
        newCategoryList.template.categories = catList;
        newCategoryList.template.categories.updated_at = timestamp();
        return newCategoryList;
      });
    }
  };

  const onDragEndComment = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedItems = reorder(commentLines, result.source.index, result.destination.index);
    reorderedItems.forEach((x, i) => {
      x.order = i + 1;
      x.updated_at = timestamp();
      x.is_selected_updated_at = timestamp(reorderedItems.length - x.order);
      return x;
    });
    setCommentLines(reorderedItems);
    const catList = AllCategoryList?.template?.categories;
    let toastStatus = null;
    catList.map((cat) => {
      if (cat.lines !== null) {
        cat?.lines?.map((line) => {
          if (line.line_id === selectedID) {
            line.comments = reorderedItems;
            line.updated_at = timestamp();
            toastStatus = "noToast";
          }
          return line;
        });
      }
      return cat;
    });
    if (toastStatus === "noToast") {
      filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
      updateTemplate("noToast");
      setAllCategoryList((prev) => {
        const newCategoryList = { ...AllCategoryList };
        newCategoryList.template.categories = catList;
        newCategoryList.template.categories.updated_at = timestamp();
        return newCategoryList;
      });
    }
  };

  const DescHolder = [
    {
      line_input_control_id: uuids2 /*uuid */,
      uuid: uuids2,
      updated_at: timestamp(),
      prompt: "Description",
      values: [
        {
          value: "check 1",
          uuid: uuids3,
          is_selected: false,
          created_at: timestamp(),
          updated_at: timestamp(),
          is_deleted: 0,
          order: 1,
        },
        {
          value: "check 2",
          uuid: uuids4,
          is_selected: false,
          created_at: timestamp(),
          updated_at: timestamp(),
          is_deleted: 0,
          order: 2,
        },
        {
          value: "check 3",
          uuid: uuids5,
          is_selected: false,
          created_at: timestamp(),
          updated_at: timestamp(),
          is_deleted: 0,
          order: 3,
        },
      ],
      type: "Description",
      data: [],
    },
  ];

  const MediaHolder = [
    {
      line_input_control_id: uuids4 /*uuid */,
      created_at: timestamp(),
      updated_at: timestamp(),
      uuid: uuids4,
      prompt: "Media",
      values: [],
      type: "Media",
      data: [],
    },
  ];

  const MediaCmtHolder = [
    {
      comment_input_control_id: small_id,
      uuid: small_id,
      created_at: timestamp(),
      updated_at: timestamp(),
      prompt: "Media",
      values: [],
      type: "Media",
      data: [],
    },
  ];

  const InfoHolder = [
    {
      line_input_control_id: uuids3 /*uuid */,
      uuid: uuids3,
      created_at: timestamp(),
      updated_at: timestamp(),
      prompt: "Information",
      values: [
        {
          value: " ",
        },
      ],
      type: "Information",
      data: [],
    },
  ];

  const LocationHolder = [
    {
      line_input_control_id: uuids5 /*uuid */,
      uuid: uuids5,
      created_at: timestamp(),
      updated_at: timestamp(),
      prompt: "Location",
      values: [],
      type: "Location",
      data: [],
    },
  ];
  const locUuid = uuid();
  const ratingUuid = uuid();
  const cmtLocHolder = [
    {
      comment_input_control_id: locUuid,
      uuid: locUuid,
      created_at: timestamp(),
      updated_at: timestamp(),
      prompt: "Location",
      is_manual_promt_edit: 0,
      values: [],
      type: "Location",
      data: [],
    },
  ];

  const cmtRating = [
    {
      comment_input_control_id: ratingUuid,
      uuid: ratingUuid,
      updated_at: timestamp(),
      prompt: "Rating",
      values: [],
      type: "Rating",
      data: [],
    },
  ];

  const handleUpdateDesc = (selectedID, type) => {
    setState((prevState) => ({ ...prevState, editDesc: false }));
    let catList = AllCategoryList?.template?.categories;
    const categoriesDataIndex = catList.findIndex((cat) => cat.category_id === categoryId);
    const lineIndex = catList[categoriesDataIndex].lines.findIndex((line) => line.line_id === lineId);
    const locationIndex = catList[categoriesDataIndex].lines[lineIndex].line_input_controls.findIndex((info) => info.line_input_control_id === selectedID);
    if (locationIndex === -1) {
      let lineUpdatedData;
      if (type.toLowerCase() === "description") {
        lineUpdatedData = DescHolder;
        lineUpdatedData[0].prompt = editDescText;
        lineUpdatedData[0].updated_at = timestamp();
      }
      if (type.toLowerCase() === "location") {
        lineUpdatedData = LocationHolder;
        lineUpdatedData[0].prompt = editDescText;
        lineUpdatedData[0].updated_at = timestamp();
      }
      if (type.toLowerCase() === "media") {
        lineUpdatedData = MediaHolder;
        lineUpdatedData[0].prompt = editDescText;
        lineUpdatedData[0].updated_at = timestamp();
      }
      if (type.toLowerCase() === "information") {
        lineUpdatedData = InfoHolder;
        lineUpdatedData[0].prompt = editDescText;
        lineUpdatedData[0].updated_at = timestamp();
      }
      catList[categoriesDataIndex].lines[lineIndex].line_input_controls = [...catList[categoriesDataIndex].lines[lineIndex].line_input_controls, ...lineUpdatedData];
    } else {
      catList[categoriesDataIndex].lines[lineIndex].line_input_controls[locationIndex].prompt = editDescText;
      catList[categoriesDataIndex].lines[lineIndex].line_input_controls[locationIndex].updated_at = timestamp();
    }
    filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
    updateTemplate("noToast");
    setAllCategoryList((prev) => {
      const newCategoryList = { ...AllCategoryList };
      newCategoryList.template.categories = catList;
      newCategoryList.template.categories.updated_at = timestamp();
      return newCategoryList;
    });
  };

  const removeDescription = (selectedID, type, remove) => {
    setState((prevState) => ({
      ...prevState,
      isExpanded: { ...isExpanded, [selectedID]: remove ? false : true },
    }));
    setAnchorEl(null);
    let catList = AllCategoryList?.template?.categories;
    const categoriesDataIndex = catList.findIndex((cat) => cat.category_id === categoryId);
    const lineIndex = catList[categoriesDataIndex].lines.findIndex((line) => line.line_id === lineId);
    const locationIndex = catList[categoriesDataIndex].lines[lineIndex].line_input_controls.findIndex((info) => info.line_input_control_id === selectedID);
    if (locationIndex === -1) {
      let lineUpdatedData;
      if (type.toLowerCase() === "description") {
        lineUpdatedData = DescHolder;
        lineUpdatedData[0].is_disabled = remove;
        lineUpdatedData[0].updated_at = timestamp();
      }
      if (type.toLowerCase() === "location") {
        lineUpdatedData = LocationHolder;
        lineUpdatedData[0].is_disabled = remove;
        lineUpdatedData[0].updated_at = timestamp();
      }
      if (type.toLowerCase() === "media") {
        lineUpdatedData = MediaHolder;
        lineUpdatedData[0].is_disabled = remove;
        lineUpdatedData[0].updated_at = timestamp();
      }
      if (type.toLowerCase() === "information") {
        lineUpdatedData = InfoHolder;
        lineUpdatedData[0].is_disabled = remove;
        lineUpdatedData[0].updated_at = timestamp();
      }
      catList[categoriesDataIndex].lines[lineIndex].line_input_controls = [...catList[categoriesDataIndex].lines[lineIndex].line_input_controls, ...lineUpdatedData];
    } else {
      catList[categoriesDataIndex].lines[lineIndex].line_input_controls[locationIndex].is_disabled = remove;
      catList[categoriesDataIndex].lines[lineIndex].line_input_controls[locationIndex].updated_at = timestamp();
    }
    filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
    updateTemplate("noToast");
    setAllCategoryList((prev) => {
      const newCategoryList = { ...AllCategoryList };
      newCategoryList.template.categories = catList;
      newCategoryList.template.categories.updated_at = timestamp();
      return newCategoryList;
    });
  };

  const handleExpansion = (itemData, isStatic) => {
    if (!itemData.is_disabled || itemData.is_disabled === undefined) {
      let newData;
      if (isStatic) {
        newData = isStaticExpanded;
        newData[itemData.type] = !isStaticExpanded[itemData.type];
      } else {
        newData = isExpanded;
        newData[itemData.line_input_control_id] = !isExpanded[itemData.line_input_control_id];
      }
      setState((prevState) => ({
        ...prevState,
        isExpanded: newData,
      }));
    }
  };

  const inputRef = useRef(null);
  useEffect(() => {
    if (editDesc && inputRef.current) inputRef.current.focus();
  }, [editDesc]);

  function decodeHtmlEntities(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  const renderTEComponents = (itemData, type, isStatic, accordionDetail) => {
    return itemData.is_deleted ? (
      ""
    ) : (
      <Grid container display={"flex"} mb={3} key={isStatic ? itemData.type : itemData?.line_input_control_id}>
        <Grid item xs={12}>
          <Accordion
            expanded={
              itemData.is_disabled
                ? false
                : isStatic
                  ? isStaticExpanded[itemData?.type]
                  : isExpanded[itemData?.line_input_control_id] === undefined
                    ? true
                    : isExpanded[itemData?.line_input_control_id]
            }
            onChange={() => handleExpansion(itemData, isStatic)}
            className="accordionBox accordionSumFocus">
            <AccordionSummary className="accordionSumDesc accordionSumFocus">
              <Grid container gap={0.7}>
                <Grid item xs={itemData?.is_disabled ? 11.2 : 9.3} md={itemData?.is_disabled ? 11.2 : 9.3} sm={itemData?.is_disabled ? 11.3 : 10.6} lg={itemData?.is_disabled ? 11.3 : 10.6}>
                  {editDesc && ((isStatic && itemData?.type === selectedItem?.type) || (!isStatic && itemData?.line_input_control_id === selectedItem?.line_input_control_id)) ? (
                    <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={() => handleUpdateDesc(itemData.line_input_control_id, type)}>
                      <input
                        type="text"
                        name="title"
                        value={editDescText}
                        onKeyDown={(e) => e.keyCode === 13 && handleUpdateDesc(itemData.line_input_control_id, type)}
                        onFocus={(event) => event.target.select()}
                        ref={inputRef}
                        autoFocus
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            editDescText: e.target.value,
                          }));
                        }}
                        className="accordionTitle"
                      />
                    </ClickAwayListener>
                  ) : (
                    <Grid container display={"flex"} gap={0.1}>
                      <Grid
                        item
                        xs={!itemData?.is_disabled ? 12 : 4.1}
                        sm={!itemData?.is_disabled ? 11 : 4.1}
                        md={!itemData?.is_disabled ? 12 : 4.1}
                        lg={!itemData?.is_disabled ? 11 : 4.1}
                        display={"flex"}>
                        <Typography className={itemData?.is_disabled ? "accordionTitleDisable" : "accordionTitle"}>{itemData?.prompt}</Typography>
                      </Grid>
                      {itemData?.is_disabled ? (
                        <Grid item xs={12} sm={7.8} md={12} lg={7.8} display={"flex"} alignItems={"center"}>
                          <Typography className="titleDisable">{`*This form element has been removed and will not be published.`}</Typography>
                        </Grid>
                      ) : null}
                    </Grid>
                  )}
                </Grid>
                {itemData?.is_disabled ? (
                  <Grid item xs={0.5} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                    <BootstrapTooltip title={<h1>Add form element</h1>}>
                      <AddCircleOutlineRoundedIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          removeDescription(itemData?.line_input_control_id, type, 0);
                        }}
                      />
                    </BootstrapTooltip>
                  </Grid>
                ) : (
                  <>
                    <Grid item sm={0.5} xs={1} md={1} lg={0.5} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                      {!(
                        (isStatic && isStaticExpanded[itemData.type]) ||
                        (!isStatic && isExpanded[itemData?.line_input_control_id] === undefined ? true : isExpanded[itemData?.line_input_control_id])
                      ) ? (
                        <ExpandMoreIcon
                          onClick={(event) => {
                            event.stopPropagation();
                            handleExpansion(itemData, isStatic);
                          }}
                        />
                      ) : (
                        <ExpandLessIcon
                          onClick={(event) => {
                            event.stopPropagation();
                            handleExpansion(itemData, isStatic);
                          }}
                        />
                      )}
                    </Grid>
                      <Grid item sm={0.5} xs={1} md={1} lg={0.5} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                        <MoreHorizIcon
                          onClick={(event) => {
                            event.stopPropagation();
                            setState((prevState) => ({
                              ...prevState,
                              selectedItem: itemData,
                            }));
                            setAnchorEl(event.currentTarget);
                            handleClick("bottom-end")(event);
                          }}
                        />
                      </Grid>
                  </>
                )}
              </Grid>
            </AccordionSummary>
            <AccordionDetails>{accordionDetail}</AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
        <Popper open={open} anchorEl={anchorEl} placement={placement} transition>
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <ClickAwayListener onClickAway={handleClickAway}>
                  <div style={{ padding: "10px" }}>
                    {/* Information never had an editable title; media/location keep theirs
                        except on Texas templates, where the titles are fixed. */}
                    {selectedItem?.type?.toLowerCase() === "information" ||
                      (isTexasTemplate && ["media", "location"].includes(selectedItem?.type?.toLowerCase())) ? null : (
                      <MenuItem
                        style={{ padding: "8px" }}
                        onClick={() => {
                          setState((prevState) => ({
                            ...prevState,
                            editDesc: true,
                            editDescText: selectedItem.prompt,
                          }));
                          setAnchorEl(null);
                        }}>
                        <EditIcon className="editDescIcon" />
                        <Typography className="editDescText">Edit Title</Typography>
                      </MenuItem>
                    )}
                    <MenuItem style={{ padding: "8px" }} onClick={() => removeDescription(selectedItem?.line_input_control_id, selectedItem?.type, 1)}>
                      <RemoveCircleOutlineRoundedIcon className="editDescIcon" />
                      <Typography className="editDescText">Remove Form Element</Typography>
                    </MenuItem>
                  </div>
                </ClickAwayListener>
              </Paper>
            </Fade>
          )}
        </Popper>
      <>
        {!isInspection && !AllCategoryList?.template?.is_narrative_template ? (
          <>
            {DescArray.length === 0
              ? DescHolder.map((item) =>
                renderTEComponents(
                  item,
                  "description",
                  true,
                  <CheckDescription
                    item={item}
                    type={item.type}
                    prompt={item.prompt}
                    isPlaceHolder={true}
                    values={item.values}
                    categoryId={categoryId}
                    TriggerClick={TriggerClick}
                    renId={renId}
                    renamingId={(id) => renamingId(id)}
                    AllCategoryList={AllCategoryList}
                    selectedID={item.line_input_control_id}
                    lineId={lineId}
                    updateTemplate={updateTemplate}
                  />
                )
              )
              : DescArray.map((item) =>
                renderTEComponents(
                  item,
                  "description",
                  false,
                  <CheckDescription
                    item={item}
                    type={item.type}
                    prompt={item.prompt}
                    isPlaceHolder={false}
                    values={item.values}
                    categoryId={categoryId}
                    TriggerClick={TriggerClick}
                    renId={renId}
                    renamingId={(id) => renamingId(id)}
                    AllCategoryList={AllCategoryList}
                    selectedID={item.line_input_control_id}
                    lineId={lineId}
                    updateTemplate={updateTemplate}
                  />
                )
              )}
          </>
        ) : null}
        {CheckBoxArray.map((item) => {
          return item.is_deleted ? (
            ""
          ) : (
            <>
              <Typography className="maincat"> {item.prompt}</Typography>
              <CheckDescription
                item={item}
                type={item.type}
                prompt={item.prompt}
                values={item.values}
                isPlaceHolder={false}
                categoryId={categoryId}
                TriggerClick={TriggerClick}
                renId={renId}
                renamingId={(id) => renamingId(id)}
                AllCategoryList={AllCategoryList}
                selectedID={item.line_input_control_id}
                lineId={lineId}
                updateTemplate={updateTemplate}
              />
            </>
          );
        })}
        {TempArray.map((item) => {
          return item.is_deleted ? (
            ""
          ) : (
            <>
              <Typography sx={{ pb: "25px" }} style={{ minWidth: "40px", minHeight: "40px" }} className="section">
                Numeric input. Select Farenheit or Celcius as default.
              </Typography>
              <Temprature data={item.data} categoryId={categoryId} AllCategoryList={AllCategoryList} updateTemplate={updateTemplate} selectedID={item.line_input_control_id} />
            </>
          );
        })}
        {TextArray.map((item) => {
          return item.is_deleted ? (
            ""
          ) : (
            <>
              <Typography sx={{ pb: "25px" }} style={{ minWidth: "40px", minHeight: "40px" }} className="section">
                Text input. Use for short answer information
              </Typography>
              <TextInput data={item.data} categoryId={categoryId} AllCategoryList={AllCategoryList} updateTemplate={updateTemplate} selectedID={item.line_input_control_id} />
            </>
          );
        })}

{!isInspection && !AllCategoryList?.template?.is_narrative_template && !isTexasTemplate ? (
        <Grid  mb={3}>
          <Grid item xs={12} sm={7} md={6}>
            <Accordion
              expanded={isRatingExpanded}
              onChange={() => setIsRatingExpanded((p) => !p)}
              className="accordionBox accordionSumFocus"
            >
              <AccordionSummary className="accordionSumDesc accordionSumFocus">
                <Grid container alignItems="center" wrap="nowrap" gap={1}>
                  <Grid item flexGrow={1}>
                    <Typography className="accordionTitle">Rating</Typography>
                  </Grid>
                  <Grid item display={"flex"} alignItems={"center"}>
                    {isRatingExpanded
                      ? <ExpandLessIcon fontSize="small" onClick={(e) => { e.stopPropagation(); setIsRatingExpanded(false); }} />
                      : <ExpandMoreIcon fontSize="small" onClick={(e) => { e.stopPropagation(); setIsRatingExpanded(true); }} />}
                  </Grid>
                  <Grid item display={"flex"} alignItems={"center"}>
                    <MoreHorizIcon fontSize="small" />
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid item xs={12} sm={7} md={6} sx={{ mt: "6px", mb: "8px" }}>
                  <FormControl fullWidth>
                    <Autocomplete
                      multiple
                      size="small"
                      limitTags={2}
                      options={ratingsMap}
                      value={Array.isArray(lineRatingValue) ? lineRatingValue : []}
                      onChange={(e, value) => handleLineRatingChange(value)}
                      isOptionEqualToValue={(option, value) =>
                        option.Id === value.Id ||
                        (option.Name === value.Name &&
                          option.Color === value.Color &&
                          parseInt(option.include_in_summary) === parseInt(value.include_in_summary))
                      }
                      disableCloseOnSelect
                      getOptionLabel={(option) => option?.Name || option?.name || ""}
                      renderTags={(tagValues, getTagProps) =>
                        tagValues.map((option, index) => {
                          const tagProps = getTagProps({ index });
                          const color = resolveRatingColor(option);
                          const flagged = resolveRatingFlagged(option);
                          return (
                            <Box
                              key={option?.Id ?? index}
                              {...tagProps}
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.75,
                                px: 0.5,
                                py: 0,
                                pl: 1,
                                borderRadius: "16px",
                                backgroundColor: "#FFF",
                                border: "1px solid #CED2DA",
                                color: "#637083",
                                fontSize: 12,
                                fontWeight: 600,
                              }}
                            >
                              <span style={{ height: 15, width: 15, backgroundColor: color, borderRadius: 5, flexShrink: 0 }}>
                                {flagged ? <FlagIcon sx={{ color: "white", fontSize: 15 }} /> : null}
                              </span>
                              <span style={{ maxWidth: 140, color: "#637083", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginTop: 2 }}>
                                {resolveRatingName(option)}
                              </span>
                              <IconButton size="small" onClick={tagProps.onDelete} sx={{ height: 20, width: 20, ml: 0.25, color: "#fff", backgroundColor: "#97A1AF" }}>
                                <CloseOutlinedIcon sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Box>
                          );
                        })
                      }
                      renderOption={(props, option) => {
                        const isSelected = (Array.isArray(lineRatingValue) ? lineRatingValue : []).some(
                          (v) => v.Id === option.Id ||
                            (v.Name === option.Name && v.Color === option.Color &&
                              parseInt(v.include_in_summary) === parseInt(option.include_in_summary))
                        );
                        return (
                          <li {...props} key={option.Id}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              checked={isSelected}
                            />
                            <Box
                              sx={{
                                width: 15,
                                height: 15,
                                backgroundColor: option?.color || option?.Color,
                                borderRadius: "2px",
                                mr: 1,
                                flexShrink: 0,
                              }}
                            >
                              {parseInt(option?.include_in_summary) === 1
                                ? <FlagIcon sx={{ color: "white", fontSize: 15, mb: 0.3 }} />
                                : null}
                            </Box>
                            {option?.Name || option?.name}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder={(Array.isArray(lineRatingValue) ? lineRatingValue : []).length === 0 ? "Select rating" : ""}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      ) : null}
        {isInspection !== 1 && !AllCategoryList?.template?.is_narrative_template ? (
          <>
            <Typography sx={{ mb: "25px" }} className="maincat">
              Additional Inputs
            </Typography>
            <Grid>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="MainCategory">
                  {(provided) => (
                    <div ref={provided.innerRef}>
                      {additional?.map((item, index) => {
                        return item.is_deleted ? (
                          ""
                        ) : (
                          <Draggable draggableId={String(item.line_input_control_id)} key={item.line_input_control_id} index={index}>
                            {(provided) => (
                              <div key={index} ref={provided.innerRef} {...provided.draggableProps}>
                                {
                                  <AdditionalSection
                                    dragHandleProps={provided.dragHandleProps}
                                    from={`additional_${item.line_input_control_id}`}
                                    type={item.type}
                                    prompt={item.prompt}
                                    values={item.values}
                                    isPlaceHolder={false}
                                    item={item}
                                    categoryId={categoryId}
                                    TriggerClick={TriggerClick}
                                    renId={renId}
                                    activeRename={activeRename}
                                    isChanged={isChanged}
                                    updateTemplate={updateTemplate}
                                    checkActiveFocus={checkActiveFocus}
                                    renamingId={(id) => renamingId(id)}
                                    AllCategoryList={AllCategoryList}
                                    setAllCategoryList={setAllCategoryList}
                                    selectedID={item.line_input_control_id}
                                    lineId={lineId}
                                    actions={{
                                      CloseMenu: (event) => CloseMenu(event),
                                      stopActive: (event) => stopActive(event),
                                      OpenMenu: (event, id) => OpenMenu(event, id),
                                      ActiveId,
                                      menu,
                                    }}
                                  />
                                }
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              {isInspection !== 1 && (
                <div style={{ paddingBottom: "52px" }}>
                  <TemplateAdd name={"Additional input"} HandleCreateSite={() => HandleCreateNewDescription(lineId)} />
                </div>
              )}
            </Grid>
          </>
        ) : null}
        {!isInspection && !AllCategoryList?.template?.is_narrative_template ? (
          <>
            {MediaArray.length === 0
              ? MediaHolder.map((item) =>
                renderTEComponents(
                  item,
                  "media",
                  true,
                  item?.type === "Media" && (
                    <ImageSection
                      images={item.data}
                      isPlaceHolder={true}
                      item={item}
                      AllCategoryList={AllCategoryList}
                      categoryId={categoryId}
                      lineId={lineId}
                      lineInputControlId={item.line_input_control_id}
                      updateTemplate={updateTemplate}
                    />
                  )
                )
              )
              : MediaArray.map((item) =>
                renderTEComponents(
                  item,
                  "media",
                  false,
                  item.type === "Media" && (
                    <ImageSection
                      images={item.data}
                      isPlaceHolder={false}
                      item={item}
                      AllCategoryList={AllCategoryList}
                      categoryId={categoryId}
                      lineId={lineId}
                      lineInputControlId={item.line_input_control_id}
                      updateTemplate={updateTemplate}
                    />
                  )
                )
              )}
            {AllCategoryList?.template?.is_hip_template !== 1 ?
              LocationArray.length === 0
                ? LocationHolder.map((item) =>
                  renderTEComponents(
                    item,
                    "location",
                    true,
                    <LocationSection
                      locationData={AllCategoryList?.template?.location_data}
                      prompt={item.prompt}
                      isPlaceHolder={true}
                      item={item}
                      AllCategoryList={AllCategoryList}
                      categoryId={categoryId}
                      lineId={lineId}
                      lineInputControlId={item.line_input_control_id}
                      updateTemplate={updateTemplate}
                    />
                  )
                )
                : LocationArray.map((item) =>
                  renderTEComponents(
                    item,
                    "location",
                    false,
                    <LocationSection
                      locationData={AllCategoryList?.template?.location_data}
                      prompt={item.prompt}
                      isPlaceHolder={false}
                      item={item}
                      AllCategoryList={AllCategoryList}
                      categoryId={categoryId}
                      lineId={lineId}
                      lineInputControlId={item.line_input_control_id}
                      updateTemplate={updateTemplate}
                    />
                  )
                ) : null}
            {InformationArray.length === 0
              ? InfoHolder.map((item) =>
                renderTEComponents(
                  item,
                  "information",
                  true,
                  <InformationSection
                    updateTemplate={updateTemplate}
                    isPlaceHolder={true}
                    item={item}
                    informationData={item.values.length !== 0 ? item.values[0].value : " "}
                    prompt={item.prompt}
                    AllCategoryList={AllCategoryList}
                    setAllCategoryList={setAllCategoryList}
                    categoryId={categoryId}
                    lineId={lineId}
                    lineInputControlId={item.line_input_control_id}
                  />
                )
              )
              : InformationArray.map((item) =>
                renderTEComponents(
                  item,
                  "information",
                  false,
                  <InformationSection
                    updateTemplate={updateTemplate}
                    isPlaceHolder={false}
                    item={item}
                    informationData={item.values.length !== 0 ? item.values[0].value : " "}
                    prompt={item.prompt}
                    AllCategoryList={AllCategoryList}
                    setAllCategoryList={setAllCategoryList}
                    categoryId={categoryId}
                    lineId={lineId}
                    lineInputControlId={item.line_input_control_id}
                  />
                )
              )}
          </>
        ) : null}
      </>
     
      {isInspection !== 1 && !AllCategoryList?.template?.is_narrative_template ? (
        <>
          <Grid container display={"flex"}>
            <Grid item xs={9}>
              <Typography className="line-header" sx={{ marginTop: "0px" }}>
                Comments
              </Typography>
            </Grid>
            <Grid item xs={3} display={"flex"} justifyContent={"flex-end"}>
              <Button variant="contained" className="new-comment" onClick={() => setState((prevState) => ({ ...prevState, isCommentDialogOpen: true }))} startIcon={<AddIcon />}>
                New comment
              </Button>
            </Grid>
          </Grid>
          <Grid>
            <DragDropContext onDragEnd={onDragEndComment}>
              <Droppable droppableId="CommentDetails">
                {(provided) => (
                  <div ref={provided.innerRef}>
                    {commentLines?.length > 0 &&
                      commentLines?.map((comment, index) => {
                        setCmt(comment.comment_id);
                        return comment.is_deleted === 1 ? null : (
                          <Draggable draggableId={String(comment.comment_id)} isDragDisabled={actives && comment.comment_id === ids} key={comment.comment_id} index={index}>
                            {(provided) => (
                              <div key={index} ref={provided.innerRef} {...provided.draggableProps}>
                                {
                                  <TemplateAccord
                                    disableDnD={(isOpen, id) => disableDnD(isOpen, id)}
                                    dragHandleProps={provided.dragHandleProps}
                                    expanded={expanded}
                                    from={`comments_${comment.comment_id}_${lineId}_${categoryId}`}
                                    accordOpen={accordOpen}
                                    HeaderTitle={comment.prompt || comment?.title}
                                    manualPrompt={comment.is_mannual_prompt}
                                    recommended={(comment?.recommendation || comment?.comment_text)?.replace(/\[dropdown ([a-f0-9-]+)\]/gi, (match, uuid) => {
                                      const commentDropdownsList = Array.isArray(comment?.comment_dropdowns) ? comment.comment_dropdowns : [];
                                      const dropdown = commentDropdownsList.find(item => item.dropdown_uuid === uuid);
                                      return decodeHtmlEntities(dropdown?.selected_value?.trim() || "");
                                    }).replace(/\[textbox\s+id:([^;\]]+);(?:\s*value:([^;]*))?.*?\]/gi,
                                      (match, id, value) => decodeHtmlEntities(value?.trim() || ""))
                                      .replace(/<button\b[^>]*>.*?<\/button>/gi, "")
                                      .replace(/<\/?[^>]+(>|$)/g, "")
                                      .trim()}
                                    handleChange={(panel) => handleChange(panel)}
                                    AllCategoryList={AllCategoryList}
                                    setAllCategoryList={setAllCategoryList}
                                    selectedID={comment.comment_id}
                                    TriggerClick={TriggerClick}
                                    activeRename={activeRename}
                                    isChanged={isChanged}
                                    renId={renId}
                                    updateTemplate={updateTemplate}
                                    checkActiveFocus={checkActiveFocus}
                                    renamingId={(id) => renamingId(id)}
                                    lineComId={lineId}
                                    categoryId={categoryId}
                                    innerTemplate={
                                      <CommentsSection
                                        MediaHolder={MediaCmtHolder}
                                        commentData={comment}
                                        cmtRating={cmtRating}
                                        categoryId={categoryId}
                                        lineId={lineId}
                                        cmtLocHolder={cmtLocHolder}
                                        AllCategoryList={AllCategoryList}
                                        setAllCategoryList={setAllCategoryList}
                                        updateTemplate={updateTemplate}
                                        commentId={comment.comment_id}
                                        isCommentDialogOpen={isCommentDialogOpen}
                                      />
                                    }
                                    actions={{
                                      CloseMenu: (event) => CloseMenu(event),
                                      stopActive: (event) => stopActive(event),
                                      OpenMenu: (event, id) => OpenMenu(event, id),
                                      ActiveId,
                                      menu,
                                    }}
                                  />
                                }
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Grid>
          <NonNarrativeAddComment
            open={isCommentDialogOpen}
            setState={setState}
            AllCategoryList={AllCategoryList}
            updateTemplate={updateTemplate}
            templateId={AllCategoryList?.template_id}
            categoryId={categoryId}
            categoryName={categoryName}
            lineId={lineId}
            addNewCommentHandle={addNewCommentHandle}
            setAllCategoryList={setAllCategoryList}
            cmtRating={cmtRating}
            cmtLocHolder={cmtLocHolder}
          />
        </>
      ) : null}
      {AllCategoryList?.template?.is_narrative_template ? (
        <>
          <Grid container display={"flex"}>
            <Grid item xs={9}>
              <Typography className="line-header" sx={{ marginTop: "0px" }}>
                Comments
              </Typography>
            </Grid>
            <Grid item xs={3} display={"flex"} justifyContent={"flex-end"}>
              <Button
                variant="contained"
                className="new-comment"
                onClick={() => {
                  dispatch(setShowCommentLibraryModal({ open: true, selectedLine: lineItem, selectedCategory: { id: categoryId, name: categoryName, uuid: categoryUuid } }));
                  dispatch(setEditorListner(false));
                }}
                startIcon={<AddIcon />}>
                New comment
              </Button>
            </Grid>
          </Grid>
          <Grid>
            <DragDropContext onDragEnd={onDragEndComment}>
              <Droppable droppableId="NarrativeCommentDetails">
                {(provided) => (
                  <div ref={provided.innerRef}>
                    {commentLines?.length > 0 &&
                      commentLines?.map((comment, index) => {
                        setCmt(comment.comment_id);
                        return comment.is_deleted === 1 ? null : (
                          <Draggable draggableId={String(comment.comment_id)} isDragDisabled={actives && comment.comment_id === ids} key={comment.comment_id} index={index}>
                            {(provided) => (
                              <div key={index} ref={provided.innerRef} {...provided.draggableProps}>
                                {
                                  <TemplateAccord
                                    disableDnD={(isOpen, id) => disableDnD(isOpen, id)}
                                    expanded={expanded}
                                    dragHandleProps={provided.dragHandleProps}
                                    from={`comments_${comment.comment_id}_${lineId}_${categoryId}`}
                                    accordOpen={accordOpen}
                                    HeaderTitle={comment.title}
                                    manualPrompt={comment.is_mannual_prompt}
                                    recommended={(comment?.comment_text || "")
                                      ?.replace(/\[dropdown ([a-f0-9-]+)\]/gi, (match, uuid) => {
                                        const commentDropdownsList = Array.isArray(comment?.comment_dropdowns) ? comment.comment_dropdowns : [];
                                        const dropdown = commentDropdownsList.find(item => item.dropdown_uuid === uuid);
                                        return decodeHtmlEntities(dropdown?.selected_value?.trim() || "");
                                      })
                                      .replace(/\[textbox\s+id:([^;\]]+);(?:\s*value:([^;]*))?.*?\]/gi,
                                        (match, id, value) => decodeHtmlEntities(value?.trim() || ""))
                                      .replace(/<button\b[^>]*>.*?<\/button>/gi, "")
                                      .replace(/<\/?[^>]+(>|$)/g, "")
                                      .trim()
                                    }
                                    handleChange={(panel) => handleChange(panel)}
                                    AllCategoryList={AllCategoryList}
                                    setAllCategoryList={setAllCategoryList}
                                    selectedID={comment.comment_id}
                                    TriggerClick={TriggerClick}
                                    activeRename={activeRename}
                                    isChanged={isChanged}
                                    renId={renId}
                                    item={comment}
                                    lineItem={lineItem}
                                    categoryName={categoryName}
                                    categoryId={categoryId}
                                    checkActiveFocus={checkActiveFocus}
                                    updateTemplate={updateTemplate}
                                    renamingId={(id) => renamingId(id)}
                                    lineComId={lineId}
                                    categoryUuid={categoryUuid}
                                    innerTemplate={
                                      <NarrativeCommentSection
                                        commentData={comment}
                                        categoryId={categoryId}
                                        categoryName={categoryName}
                                        lineId={lineId}
                                        AllCategoryList={AllCategoryList}
                                        setAllCategoryList={setAllCategoryList}
                                        updateTemplate={updateTemplate}
                                        commentId={comment.comment_id}
                                      />
                                    }
                                    actions={{
                                      CloseMenu: (event) => CloseMenu(event),
                                      stopActive: (event) => stopActive(event),
                                      OpenMenu: (event, id) => OpenMenu(event, id),
                                      ActiveId,
                                      menu,
                                    }}
                                  />
                                }
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Grid>
          <CommentLibraryModal
            AllCategoryList={AllCategoryList}
            setAllCategoryList={setAllCategoryList}
            updateTemplate={updateTemplate}
            templateId={AllCategoryList?.template_id}
            categoryId={categoryId}
            categoryName={categoryName}
            lineId={lineId}
          />
        </>
      ) : null}
    </div>
  );
};

export default MainCategory;
